import { PDFDocument } from 'pdf-lib';
import type { SignatureImageOverlay } from './minimalTextPdf';

/** Embed signature PNGs onto a base PDF using pdf-lib (reliable cross-viewer rendering). */
export async function overlaySignatureImages(
  pdfBytes: Uint8Array,
  overlays: SignatureImageOverlay[],
): Promise<Uint8Array> {
  if (overlays.length === 0) return pdfBytes;

  const doc = await PDFDocument.load(pdfBytes);
  const pages = doc.getPages();

  for (const overlay of overlays) {
    const page = pages[overlay.pageNumber - 1];
    if (!page) continue;

    const image = await doc.embedPng(overlay.pngBytes);
    page.drawImage(image, {
      x: overlay.x,
      y: overlay.y,
      width: overlay.width,
      height: overlay.height,
    });
  }

  return new Uint8Array(await doc.save());
}
